import React from "react";

export { Layout } from "../layout/main";

export default function About() {
  return <h1>About</h1>;
}
